import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CUSTOMER_DISPLAY_LIMIT } from 'pages/Customers/CustomerConstants';
import { HISTORY_DISPLAY_LIMIT } from 'pages/Customers/CustomerPointsHistoryModal/constants';
import { PageDetails } from 'types/common/Table';
import {
  CustomerFormType,
  CustomerSearchFilters,
  AdjustPointsFormType,
  CustomerPointsHistoryModalState,
} from 'types/customer/customerTypes';

export interface CustomerState {
  activeCustomerId: string | null;
  customerModalOpen: boolean;
  adjustPointsModalOpen: boolean;
  isEdit: boolean;
  CustomerValues: CustomerFormType;
  AdjustPointsValues: AdjustPointsFormType;
  showAllValidateErrors: boolean;
  countSubmit: number;
  PageFilters: CustomerSearchFilters;
  PageDetails: PageDetails;
  PointsHistoryModal: CustomerPointsHistoryModalState;
}

export const initialState: CustomerState = {
  activeCustomerId: null,
  customerModalOpen: false,
  adjustPointsModalOpen: false,
  isEdit: false,
  CustomerValues: {
    customerInfo: {
      register_store_id: '',
      entity_type: '0',
      accountNumber: '',
      first_name: '',
      cardId: '',
      branchCode: '',
      address_2: '',
      birthDate: '',
      gender: '0',
      comments: '',
    },
    customerAddress: {
      isNewAddress: true,
      address_1: '',
      zip: '',
      shippingAddress: '',
      city: '',
      state: '',
      province_id: '',
      district_id: '',
      sub_district_id: '',
    },
    customerContact: {
      last_name: '',
      phoneNumber: '',
      email: '',
      facebook: '',
      line: '',
      instagram: '',
    },
    customerFinancialInfo: {
      groupPrice: '0',
      isTaxable: '0',
    },
    customerCreditInfo: {
      dateLimit: '',
      receivableLimit: '',
    },
    pickupAddresses: [],
  },
  // CustomerValues: {
  //   first_name: '',
  //   last_name: '',
  //   accountNumber: '',
  //   phoneNumber: '',
  //   // discountGroup: '',
  //   cardId: '',
  //   branches: '',
  //   birthDate: '',
  //   address: '',
  //   city: '',
  //   state: '',
  //   zip: '',
  //   shippingAddress: '',
  //   gender: '',
  //   email: '',
  //   facebook: '',
  //   line: '',
  //   instagram: '',
  //   dateLimit: '',
  //   receivableLimit: '',
  //   groupPrice: '',
  //   isTaxable: false,
  //   comments: '',

  //   // pickupAddresses: [],
  // },
  // CustomerValues: {
  //   name: '',
  //   nickName: '',
  //   accountNumber: '',
  //   gender: '',
  //   phoneNumber: '',
  //   email: '',
  //   cardId: '',
  //   facebook: '',
  //   line: '',
  //   instagram: '',
  //   birthDate: '',
  //   dateLimit: '',
  //   receivableLimit: '',
  //   groupPrice: '',
  //   isTaxable: false,
  //   pickupAddresses: [],
  // },
  AdjustPointsValues: {
    customerName: '',
    accountNumber: '',
    historyPoints: 0,
    type: 'earn',
    point: '',
    comments: '',
  },
  showAllValidateErrors: false,
  countSubmit: 0,
  PageFilters: {
    branch: [],
    accountNumber: '',
    phoneNumber: '',
    email: '',
    name: '',
  },
  PageDetails: {
    entriesPerPage: CUSTOMER_DISPLAY_LIMIT,
    currentPage: 0,
    inputPageValue: 1,
  },

  PointsHistoryModal: {
    activePointsHistoryIndex: null,
    EditKey: null,
    PointsHistoryModalOpen: false,
    PointsHistoryValues: {
      info: {
        id: '',
        first_name: '',
        account_number: '',
        register_store_id: '',
        point_balance: '',
      },
      points_history: {
        total: 0,
        points_history: [],
      },
    },
    countSubmit: 0,
    showAllValidateErrors: false,
    FormErrorCount: 0,
    PageDetails: {
      entriesPerPage: HISTORY_DISPLAY_LIMIT,
      currentPage: 0,
      inputPageValue: 1,
    },
  },
};

const CustomerSlice = createSlice({
  name: 'Customer',
  initialState,
  reducers: {
    setCustomerModalOpen(state, action: PayloadAction<boolean>) {
      state.customerModalOpen = action.payload;
    },
    setAdjustPointsModalOpen(state, action: PayloadAction<boolean>) {
      state.adjustPointsModalOpen = action.payload;
    },
    setActiveCustomerId(state, action: PayloadAction<string | null>) {
      state.activeCustomerId = action.payload;
      state.isEdit = action.payload !== null;
    },
    setCustomerForm(state, action: PayloadAction<CustomerFormType>) {
      state.CustomerValues = action.payload;
    },
    resetCustomerForm(state) {
      state.CustomerValues = {
        customerInfo: {
          register_store_id: '',
          entity_type: '0',
          accountNumber: '',
          first_name: '',
          cardId: '',
          branchCode: '',
          address_2: '',
          birthDate: '',
          gender: '0',
          comments: '',
        },
        customerAddress: {
          isNewAddress: true,
          address_1: '',
          zip: '',
          shippingAddress: '',
          city: '',
          state: '',
          province_id: '',
          district_id: '',
          sub_district_id: '',
        },
        customerContact: {
          last_name: '',
          phoneNumber: '',
          email: '',
          facebook: '',
          line: '',
          instagram: '',
        },
        customerFinancialInfo: {
          groupPrice: '0',
          isTaxable: '0',
        },
        customerCreditInfo: {
          dateLimit: '',
          receivableLimit: '',
        },
        pickupAddresses: [],
      };
    },
    setAdjustPointsForm(state, action: PayloadAction<AdjustPointsFormType>) {
      state.AdjustPointsValues = action.payload;
    },
    setShowAllValidateCustomerErrors(state, action: PayloadAction<boolean>) {
      state.showAllValidateErrors = action.payload;
    },
    setCountCustomerSubmit(state) {
      state.countSubmit += 1;
    },
    setPageFilters: (state, action) => {
      state.PageFilters = action.payload;
    },
    setPageFiltersBranch: (state, action) => {
      state.PageFilters.branch = action.payload;
    },
    clearPageFilters: (state) => {
      state.PageFilters = {
        branch: [],
        accountNumber: '',
        phoneNumber: '',
        email: '',
        name: '',
      };
    },
    setEntriesPerPage: (state, action) => {
      state.PageDetails.entriesPerPage = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.PageDetails.currentPage = action.payload;
      state.PageDetails.inputPageValue = action.payload + 1;
    },
    setInputPageValue: (state, action) => {
      state.PageDetails.inputPageValue = action.payload;
    },

    setActivePointsHistoryIndex: (state, action) => {
      state.PointsHistoryModal.activePointsHistoryIndex = action.payload;
    },
    setPointsHistoryModalOpen: (state, action) => {
      state.PointsHistoryModal.PointsHistoryModalOpen = action.payload;
    },
    setPointsHistoryInfoValues: (state, action) => {
      state.PointsHistoryModal.PointsHistoryValues.info = action.payload;
    },
    setPointsHistoryTransactionValues: (state, action) => {
      state.PointsHistoryModal.PointsHistoryValues.points_history =
        action.payload;
    },
    setShowAllValidatePointsHistoryErrors: (state, action) => {
      state.PointsHistoryModal.showAllValidateErrors = action.payload;
    },
    setCountPointsHistorySubmit: (state) => {
      state.PointsHistoryModal.countSubmit += 1;
    },
    setPointsHistoryEditKey: (state, action) => {
      state.PointsHistoryModal.EditKey = action.payload;
    },

    setPointsHistoryEntriesPerPage: (state, action) => {
      state.PointsHistoryModal.PageDetails.entriesPerPage = action.payload;
    },
    setPointsHistoryCurrentPage: (state, action) => {
      state.PointsHistoryModal.PageDetails.currentPage = action.payload;
      state.PointsHistoryModal.PageDetails.inputPageValue = action.payload + 1;
    },
    setPointsHistoryInputPageValue: (state, action) => {
      state.PointsHistoryModal.PageDetails.inputPageValue = action.payload;
    },
  },
});

export const {
  setCustomerModalOpen,
  setAdjustPointsModalOpen,
  setActiveCustomerId,
  setCustomerForm,
  resetCustomerForm,
  setAdjustPointsForm,
  setShowAllValidateCustomerErrors,
  setCountCustomerSubmit,
  setPageFilters,
  setPageFiltersBranch,
  clearPageFilters,
  setEntriesPerPage,
  setCurrentPage,
  setInputPageValue,
  setActivePointsHistoryIndex,
  setPointsHistoryModalOpen,
  setPointsHistoryInfoValues,
  setPointsHistoryTransactionValues,
  setShowAllValidatePointsHistoryErrors,
  setCountPointsHistorySubmit,
  setPointsHistoryEditKey,
  setPointsHistoryEntriesPerPage,
  setPointsHistoryCurrentPage,
  setPointsHistoryInputPageValue,
} = CustomerSlice.actions;

export default CustomerSlice.reducer;
